'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/react-js-pagination/~/react/react.js
// module id = 434
// module chunks = 0